import React, { useState, useEffect, useRef } from "react";
import { Modal, Pagination, Table, Checkbox, Button } from "antd";
import "./DashboardTable.css";
import AccordionContent from "./AccordionContent";
import { useSelector, useDispatch } from "react-redux";
import {
  dashboardRowData,
  dashboardStyleDetailsList,
  dashboardStylePackDetailsList,
  dashboardStyleList,
  dashboardStyleListSearch,
  expandAccordion,
  resetDashboardStyleData,
  dashboardStyleSeason,
  updateSetupReady
} from "../../Redux/actions/Dashboard/Dashboard";
import BeatLoader from "react-spinners/BeatLoader";
import { useSearchParams } from "react-router-dom";
import { srStyleData } from "../../Redux/actions/Sr/Sr";
import Item from "antd/es/list/Item";
import { useNavigate } from "react-router-dom";
import { toast } from "../../UIComponents/Toast";
import { SyncOutlined } from "@ant-design/icons";
import Vendor from "./Vendor/Vendor";
import { Loader } from "../../UIComponents/Loader";

const truncateStyleDescription = (description) => {
  if (description && description.length > 25) {
    return description.substring(0, 25) + "...";
  }
  return description;
};

const columns = [
  {
    title: "Season",
    dataIndex: "Season",
    key: "Season",
    width: "5%"
  },
  {
    title: <p className="dashboard-style-title">Style</p>,
    dataIndex: "parentStyle",
    key: "parentStyle",
    render: (text, record) => (
      <div className="dashboard-style-container">
        <div>{record.parentStyle}</div>
        <div>
          {truncateStyleDescription(record.styleDescription)}
        </div>
      </div>
    ),
  },
  {
    title: "Brand",
    dataIndex: "brand",
    key: "brand",
  },
  {
    title: "Collection",
    dataIndex: "collection",
    key: "collection",
  },
  // {
  //   title: "Style Description",
  //   dataIndex: "styleDescription",
  //   key: "styleDescription",
  // },
  {
    title: "WO",
    dataIndex: "wo",
    key: "wo",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "x",
  },
  {
    title: "Vendor",
    dataIndex: "setupVendor",
    key: "vendor",
  },
  Table.EXPAND_COLUMN,
];

const DashboardTable = ({
  currentPage,
  setCurrentPage,
  pageSize,
  setPageSize,
  updateQueryParams,
  onSelectionChange,
  searchTerm,
  seasonFilter,
  selectedRows,
  ChunkSize,
  brand,
  brandId,
  status
}) => {
  const dispatch = useDispatch();
  const skipFetchRef = useRef(false);
  const isVendorUpdateRef = useRef(false);
  const containerRef = useRef(null);
  let navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const expandedRowKey = useSelector((state) => state?.Dashboard?.expandRowkey);
  const styleListData = useSelector((state) => state?.Dashboard?.styleList);
  const dashboardSearch = useSelector((state) => state?.Dashboard?.styleListSearch);
  const dashboardSearchLoader = useSelector((state) => state?.Dashboard?.searchLoader);
  const styleListDetailedData = useSelector((state) => state?.Dashboard?.styleDetailsData);
  const SeasonSearchData = useSelector((state) => state?.Dashboard?.styleListSearchFilter);
  const [visibleCount, setVisibleCount] = useState(ChunkSize);
  const [isCommentPopupOpen, setIsCommentPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isSetupReadyVendorPopupOpen, setIsSetupReadyVendorPopupOpen] = useState(false);
  const [isSetupReadyVendor, setIsSetupReadyVendor] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [currentStyleSeason, setCurrentStyleSeason] = useState("");
  const [setupReadyRecord, setSetupReadyRecord] = useState(null);
  const [accordionKey, setAccordianKey] = useState();
  useEffect(() => {
    setVisibleCount(ChunkSize);
    window.scrollTo(0, 0);
  }, [currentPage]);
  useEffect(() => {
    if (isVendorUpdateRef.current) {
      const savedCount = localStorage.getItem('dashboardVisibleCount');
      if (savedCount) {
        setVisibleCount(parseInt(savedCount));
        localStorage.removeItem('dashboardVisibleCount');
      }
      isVendorUpdateRef.current = false;
    } else {
      setVisibleCount(ChunkSize);
    }
  }, [styleListData?.results, dashboardSearch?.results]);

  useEffect(() => {
    const savedScroll = localStorage.getItem('dashboardScrollY');
    if (savedScroll) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.scrollTo(0, parseInt(savedScroll));
          localStorage.removeItem('dashboardScrollY');
        });
      });
    }
  }, [styleListData?.results, dashboardSearch?.results]);

  const onSelectChange = (keys, rows) => {
    setSelectedRowKeys(keys);
    if (onSelectionChange) {
      onSelectionChange(rows);
    }
  };
  const handleScroll = () => {
    if (containerRef.current) {
      const scrollTop = containerRef?.current?.scrollTop;
      localStorage.setItem("DashboardAutoScroll", scrollTop);
    }
  };
  useEffect(() => {
    setSelectedRowKeys(selectedRows?.map((row) => row.key) || []);
  }, [selectedRows]);

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  useEffect(() => {
    if (styleListDetailedData?.vendors?.length) {
      dispatch(expandAccordion(accordionKey));
    }
  }, [styleListDetailedData]);

  const initialData = () => {
    if (dashboardSearch?.lastUpdated && styleListData?.lastUpdated) {
      return dashboardSearch.lastUpdated > styleListData.lastUpdated
        ? dashboardSearch.results
        : styleListData.results;
    }
    return dashboardSearch?.results ?? styleListData?.results ?? [];
  };
  const handleSelectionSetupVendor = (vendors, setupReadyVendors, record) => {
    const vendorss = vendors || [];
    const setupVendors = setupReadyVendors || [];
    const filteredVendors = vendorss.filter(v =>
      (v.vendor_status === "Product Ready"|| v.vendor_status === "In Development" || v.vendor_status === "TP Verified") &&
      !setupVendors.some(sv => sv.vendor === v.vendor)
    );

    setIsSetupReadyVendor(filteredVendors);
    setSelectedVendors([]);
    setCurrentStyleSeason(record?.style_season || "");
    setSetupReadyRecord(record);

    if (filteredVendors.length > 0) {
      setIsSetupReadyVendorPopupOpen(true);
    } else {
      setIsSetupReadyVendorPopupOpen(false);
      toast.error("No vendors available for Setup Ready");
    }
  };

  const handleVendorCheck = (vendorName) => {
    setSelectedVendors((prev) =>
      prev.includes(vendorName)
        ? prev.filter(v => v !== vendorName)
        : [...prev, vendorName]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedVendors(
        isSetupReadyVendor.map(v => v.vendor)
      );
    } else {
      setSelectedVendors([]);
    }
  };

  const handleSubmitVendors = async () => {
    if (selectedVendors.length === 0) {
      toast.error("Please select at least one vendor");
      return;
    }

    try {
      const activeSetupReadyRecord = setupReadyRecord;
      localStorage.setItem("dashboardScrollY", window.scrollY);
      localStorage.setItem("dashboardVisibleCount", visibleCount);
      isVendorUpdateRef.current = true;

      // Dispatch the updateSetupReady action with only selected vendors
      await dispatch(updateSetupReady(currentStyleSeason, selectedVendors));

      // Close the modal and clear state
      setIsSetupReadyVendorPopupOpen(false);
      setIsSetupReadyVendor([]);
      setSelectedVendors([]);
      setCurrentStyleSeason("");
      setSetupReadyRecord(null);

      // Refresh the table data to show updated status
      const isSearchActive = !!(searchTerm?.trim()) ||
        (Array.isArray(seasonFilter) ? seasonFilter.length > 0 : !!seasonFilter) ||
        !!(brand?.trim()) ||
        !!(brandId) ||
        !!(status?.trim());

      if (isSearchActive) {
        await dispatch(
          dashboardStyleListSearch(
            searchTerm,
            seasonFilter,
            brand || "",
            brandId || "",
            status || "",
            pageSize,
            currentPage
          )
        );
      } else {
        await dispatch(
          dashboardStyleList(currentPage, pageSize)
        );
      }
      if (expandedRowKey === activeSetupReadyRecord?.key) {
        dispatch(
          dashboardStyleDetailsList(
            activeSetupReadyRecord?.parentStyle,
            activeSetupReadyRecord?.season_id,
            activeSetupReadyRecord?.season,
            activeSetupReadyRecord?.brand
          )
        );
      }


    } catch (error) {
      console.error("Error submitting vendors:", error);
    }
  };

  const handleCloseModal = () => {
    setIsSetupReadyVendorPopupOpen(false);
    setIsSetupReadyVendor([]);
    setSelectedVendors([]);
    setCurrentStyleSeason("");
    setSetupReadyRecord(null);
  };
  const data = [];
  initialData()?.map((item, index) => {
    console.log("wefjkewk", item);
    data.push({
      key: item?.style_season || item?.style || index.toString(),
      id: index,
      Season: <p style={{ textAlign: "center" }}>{item?.season}</p>,
      parentStyle: item?.style,
      brand: item?.brand,
      collection: item?.collection,
      styleDescription: truncateStyleDescription(item?.description),
      setupReadyCompleted: item?.is_setup_ready_completed,
      setupVendor: (
        <Vendor
          vendors={item?.vendors || []}
          setupReadyVendor={item?.setup_now_vendors || []}
          brand={item?.brand}
          style={item?.style}
          season={item?.season}
        />
      ),
      wo: item?.wo,
      season_id: item?.season_id,
      season: item?.season,
      style_season: item?.style_season,

      status: (
        <>
          <p
            className={
              item.status === "In Development" ? "development-btn"
                : item.status === "Product Ready" ? "launch-btn"
                  : item.status === "Dropped" ? "dropped-btn"
                    : item.status === "Execute" ? "adopted-btn"
                      : item.status === "TP Verified" ? "verified-btn"
                        : item.status === "Hold" ? "hold-btn"
                          : ""
            }
          >
            {item.status}
          </p>
          {((item.status === "Product Ready" || item.status === "In Development" || item.status === "TP Verified") && item.is_latest_season === true) ? (
            <div
              className="set-up-ready-btn"
              onClick={(e) => {
                e.stopPropagation();
                handleSelectionSetupVendor(item?.vendors, item?.setup_now_vendors, {
                  key: item?.style_season || item?.style || index.toString(),
                  parentStyle: item?.style,
                  season_id: item?.season_id,
                  season: item?.season,
                  brand: item?.brand,
                  style_season: item?.style_season,
                });

              }}>
              <SyncOutlined />
              <span> Set Up Ready </span>
            </div>
          ) : null}
        </>
      ),
    });
  });
  console.log("initialdata", initialData());
  const handleRowClick = (record) => {
    dispatch(
      dashboardRowData({
        status: record?.status?.props?.children,
        style: record?.parentStyle,
        season_id: record?.season_id,
        season: record?.season,
        brand: record?.brand,
      })
    );
  };
  const getTotalCount = () => {
    switch (true) {
      case !!SeasonSearchData && SeasonSearchData.count != null:
        return SeasonSearchData.count;
      case !!dashboardSearch && dashboardSearch.count != null:
        return dashboardSearch.count;
      case !!styleListData && styleListData.count != null:
        return styleListData.count;
      default:
        return 0;
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 5
      ) {
        if (visibleCount < data.length) {
          setVisibleCount((prev) => Math.min(prev + ChunkSize, data.length));
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [visibleCount, data.length]);

  const onChange = (page) => {
    setCurrentPage(page);
    updateQueryParams({
      page,
      pageSize,
      search: searchTerm,
      season: seasonFilter,
    });
  };
  const onShowSizeChange = (current, newPageSize) => {
    setCurrentPage(1);
    setPageSize(newPageSize);
    updateQueryParams({
      page: 1,
      pageSize: newPageSize,
      search: searchTerm,
      season: seasonFilter,
    });
  };

  return (
    <div className="dashboard-table-wrapper" ref={containerRef} onScroll={handleScroll}>
      {dashboardSearchLoader ? <Loader /> : null}
      <Table
        expandRowByClick
        rowClassName={(record) => {
          let vendorStatus = record.setupVendor?.props?.setupReadyVendor?.some(
            (v) => (v.vendor_status === "Product Ready"|| v.vendor_status === "In Development" || v.vendor_status === "TP Verified") && record.setupReadyCompleted === false
          );
          let vendorStatusCompleted = record.setupVendor?.props?.setupReadyVendor?.some(
            (v) => (v.vendor_status === "Product Ready"|| v.vendor_status === "In Development" || v.vendor_status === "TP Verified") && record.setupReadyCompleted === true
          );
          if (vendorStatus) {
            return "row-setup-ready";
          }
          if(vendorStatusCompleted){
            return "row-setup-ready-completed";
          }
          return "rowClassName1"
        }}
        rowSelection={rowSelection}
        columns={columns}
        pagination={false}
        dataSource={data.slice(0, visibleCount)}
        expandedRowKeys={expandedRowKey ? [expandedRowKey] : []}
        onExpand={(expanded, record) => {
          if (expanded) {
            setAccordianKey(record.key);
            const style = record?.parentStyle;
            const season_id = record?.season_id;
            const season = record?.season;
            const brand = record?.brand;
            dispatch(
              dashboardStyleDetailsList(style, season_id, season, brand)
            );
            dispatch(dashboardStylePackDetailsList(style));
          } else {
            dispatch(resetDashboardStyleData({}));
            dispatch(expandAccordion(null));
          }
        }}
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
              handleRowClick(record, rowIndex);
            },
          }
        }}
        expandable={{
          expandedRowRender: (record) => <AccordionContent />,
          rowExpandable: (record) => record.name !== "Not Expandable",
        }}
      />

      <Pagination
        total={getTotalCount()}
        current={currentPage}
        pageSize={pageSize}
        onChange={onChange}
        showSizeChanger={false}
        style={{ textAlign: "right", marginTop: "20px" }}
      />
      <Modal
        title=""
        open={isCommentPopupOpen}
        onCancel={() => setIsCommentPopupOpen(false)}
        footer={null}
        width={600}
        className="setup_modal"
      >
        {popupMessage}
      </Modal>
      <Modal
        open={isSetupReadyVendorPopupOpen}
        onCancel={() => setIsSetupReadyVendorPopupOpen(false)}
        title="Vendor Eligible for Setup Ready Sheet"
        className="setup_modal setup_ready_modal"
        footer={[
          <Button key="ok" onClick={handleSubmitVendors} className="ok-btn">
            Confirm
          </Button>,
          <Button key="cancel" onClick={handleCloseModal} className="cancel-btn">
            Cancel
          </Button>
        ]}
      >
        {/* Select All */}
        <div style={{ marginBottom: 12 }}>
          <Checkbox
            checked={
              isSetupReadyVendor.length > 0 &&
              selectedVendors.length === isSetupReadyVendor.length
            }
            onChange={handleSelectAll}
          >
            Select All
          </Checkbox>
        </div>

        {/* Vendor List */}
        {isSetupReadyVendor?.map((item, index) => (
          <div key={index} style={{ marginBottom: 10 }}>
            <Checkbox
              checked={selectedVendors.includes(item.vendor)}
              onChange={() => handleVendorCheck(item.vendor)}
            >
              {item.vendor}
            </Checkbox>
          </div>
        ))}
      </Modal>
    </div>
  );
};

export default DashboardTable;
